import { Box, Typography, CircularProgress } from "@mui/material";

export interface LoadingStateProps {
  message?: string;
}

export const LoadingState = ({ message }: LoadingStateProps) => (
  <Box
    data-testid="loading-state"
    flexDirection="column"
    rowGap={2}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    }}
  >
    <Typography variant="h4" align="center" color="primary.main" sx={{ my: 4 }}>
      {message || "Loading..."}
    </Typography>
    <CircularProgress />
  </Box>
);
